import styled from 'styled-components'
import Box from 'components/shared/Box'
import { respondAbove } from 'styles/mediaQueries'

interface SharedWrapperProps {
    isChecked: boolean
}

export const SharedWrapper = styled(Box)<SharedWrapperProps>`
    position: relative;
    border: 2px solid
        ${({ theme, isChecked }) =>
            isChecked ? theme.colors.primary_500 : 'transparent'};
    border-radius: 6px;
    padding: 16px;
    cursor: pointer;
    background-color: ${({ theme, isChecked }) => {
        if (isChecked)
            return theme.mode === 'light'
                ? theme.colors.grayscale_0
                : theme.colors.darkmode_500
        else return theme.colors.grayscale_200
    }};
    min-height: 64px;

    &:focus-within {
        border-color: ${({ theme }) => theme.colors.primary_500};
    }

    @media ${respondAbove.xl} {
        border-radius: 8px;
        min-height: 112px;
        padding: 0 40px;

        &::before,
        &::after {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            width: 16px;
            height: 100%;
            background-color: ${({ theme, isChecked }) =>
                isChecked ? theme.colors.primary_500 : 'transparent'};
        }

        &::after {
            left: 8px;
            width: 8px;
            background-color: ${({ theme, isChecked }) => {
                if (isChecked)
                    return theme.mode === 'light'
                        ? theme.colors.grayscale_0
                        : theme.colors.darkmode_500
                else return 'transparent'
            }};
            border-bottom-left-radius: 8px;
            border-top-left-radius: 8px;
        }
    }
`
